import React from 'react';

export const BalanceSkeleton = () => (
  <div className="animate-pulse">
    <div className="h-4 w-32 bg-[#1e293b] mb-4 mx-auto" />
    <div className="h-24 w-64 bg-[#1e293b] mb-2 mx-auto" />
    <div className="h-6 w-20 bg-[#1e293b] mx-auto" />
  </div>
);

export const AddressCardSkeleton = () => (
  <div className="bg-[#0f172a] border border-[#1e293b] p-6 animate-pulse">
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center">
        <div className="h-8 w-8 bg-[#1e293b] rounded mr-3" />
        <div>
          <div className="h-4 w-24 bg-[#1e293b] mb-2" />
          <div className="h-3 w-32 bg-[#1e293b]" />
        </div>
      </div>
    </div>
    <div className="h-12 bg-[#020617] border border-[#1e293b] mb-4" />
    <div className="flex gap-2">
      <div className="flex-1 h-10 bg-[#1e293b]" />
      <div className="flex-1 h-10 bg-[#1e293b]" />
    </div>
  </div>
);

export const ActivitySkeleton = () => (
  <div className="space-y-3">
    {[1, 2, 3].map((i) => (
      <div key={i} className="bg-[#020617] border border-[#1e293b] p-4 animate-pulse">
        <div className="flex justify-between">
          <div className="flex-1">
            <div className="h-4 w-32 bg-[#1e293b] mb-2" />
            <div className="h-3 w-48 bg-[#1e293b]" />
          </div>
          <div>
            <div className="h-4 w-24 bg-[#1e293b] mb-2" />
            <div className="h-3 w-16 bg-[#1e293b] ml-auto" />
          </div>
        </div>
      </div>
    ))}
  </div>
);